<div class="modal fade" role="dialog" id="legaliModificaTariffaModal">
    <div class="modal-dialog" [attr.role]="'document'">
        <div class="modal-content" *ngIf="tariffa">
            <p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
                <button class="btn btn-default-reverse btn-block btn-sm" [attr.data-dismiss]="'modal'"
                    type="button">Chiudi</button>
            </p>


            <ng-container *ngIf="isModifica && !riepilogo">
                <div class="col-sm-12 coldx">
                    <h4>Revisiona tariffa</h4>
                </div>
                <div class="row">
                    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
                        [labelInput]="'Tipo prestazione'"
                        [valueInput]="tariffa.attivita ? tariffa.attivita.descrizione : ''"></div>
                    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Grado'"
                        [valueInput]="tariffa.grado ? tariffa.grado.descrizione : ''"></div>
                    <p class="col-sm-2 col-sm-offset-2">
                        <button type="button" class="btn btn-block" (click)="ripristinaTariffaOriginale()">Ripristina
                            originale</button>
                    </p>
                </div>
                <div class="container_conteggi">
                    <h5>
                        <strong>Importi tariffa</strong>
                    </h5>
                    <div textInputCurrency [labelInput]="'Importo'" [(ngModel)]="tariffa.imponibile">
                    </div>
                    <div textInputCurrency [labelInput]="'Spese generali % art.2'" [(ngModel)]="tariffa.speseGenerali">
                    </div>
                    <div textInputCurrency [labelInput]="'Spese a pié di lista'" [isNaturalNumber]="true" [(ngModel)]="tariffa.spesePiePagina">
                    </div>
                    <div textInputCurrency [labelInput]="'Spese esenti IVA ex art. 15 DPR 633/72'"
                        [(ngModel)]="tariffa.speseEsenti">
                    </div>
                    <div textInputCurrency [labelInput]="'Maggiorazione p.d. '" [(ngModel)]="tariffa.maggiorazione" [maxValue]="100" [isNaturalNumber]="true">
                    </div>
                </div>
                <div class="container_conteggi">
                    <h5>
                        <strong>Accessori</strong>
                    </h5>

                    <div class="row">
                        <div class="parcella_accessori col-sm-offset-2">
                            <div singleCheckBoxModInput class="col-xs-6 col-sm-2" [labelInput]="''" idInput="flagIva"
                                (onReturn)="flagIVA = $event" [labelChecked]="'IVA'" [labelNotChecked]="'IVA'"
                                [objectReference]="flagIVA"></div>

                            <div comboModInput class="col-xs-6 col-sm-3" [labelInput]="''" [labelOption]="'valore'"
                                [submitPending]="!flagIVA" [optionsCombo]="ivaOptions$ | async"
                                (onReturn)="tariffa.iva = $event" [objectReference]="tariffa.iva"></div>

                            <div class="col-xs-6 col-sm-2" singleCheckBoxModInput [labelInput]="''" (onReturn)="flagCPA = $event"
                                [labelChecked]="'CPA'" [labelNotChecked]="'CPA'" [showLabel]="true"
                                [objectReference]="flagCPA"></div>

                            <div comboModInput class="col-xs-6 col-sm-3" [labelInput]="''" [labelOption]="'valore'"
                                [optionsCombo]="cpaOptions$ | async" [submitPending]="!flagCPA"
                                (onReturn)="tariffa.cpa = $event" [objectReference]="tariffa.cpa"></div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-6 visible-xs"></div>
                    <div submitButton class="col-sm-3 col-xs-6 col-sm-offset-9"
                        (click)="riepilogo = true;" [labelButton]="'Calcola tariffa'"></div>
                </div>
            </ng-container>

            <ng-container *ngIf="riepilogo || !isModifica">
                <div>
                    <div class="titleblock">
                        <h3 class="title1levelNoMargin" style="margin-bottom: 20px">Dettagli Tariffa</h3>
                    </div>
                    <div class="row">
                        <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
                            [labelInput]="'Tipo prestazione'"
                            [valueInput]="tariffa.attivita ? tariffa.attivita.descrizione : ''"></div>
                        <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Grado'"
                            [valueInput]="tariffa.grado ? tariffa.grado.descrizione : ''"></div>
                    </div>
                    <div class="container_conteggi">
                        <h5>
                            <strong>Prospetto finale</strong>
                        </h5>

                        <div labelTextInput [labelInput]="'Importo'" [typeLabel]="'conteggioProspetto'"
                    [valueInput]="tariffa.imponibile"></div>
                <div>
                <div labelTextInput [labelInput]="'Maggiorazione p.d. ' + (tariffa.maggiorazione ? tariffa.maggiorazione : 0) + '%'" [typeLabel]="'conteggioProspetto'"
                    [valueInput]="maggiorazioneCalc">
                </div>
                <div labelTextInput [labelInput]="'Totale compensi'"
                    [typeLabel]="'conteggioProspettoBold'" [valueInput]="totaleCompensi">
                </div>
                    <div labelTextInput
                        [labelInput]="('Spese generali art.2 ' + (tariffa.speseGenerali ? (tariffa.speseGenerali + '% sul compenso totale') : '0% sul compenso totale'))"
                        [typeLabel]="'conteggioProspetto'" [valueInput]="speseGenerali">
                    </div>
                </div>
                <div>
                    <div labelTextInput [labelInput]="'Spese a pié di lista'" [typeLabel]="'conteggioProspetto'"
                        [valueInput]="tariffa.spesePiePagina">
                    </div>
                    <div labelTextInput
                        [labelInput]="('Cassa avvocati ' + (tariffa.cpa ? (tariffa.cpa.valore  + '%') : '0%'))"
                        [typeLabel]="'conteggioProspetto'" [valueInput]="cpaCalc">
                    </div>
                    <div labelTextInput [labelInput]="'Totale imponibile'"
                        [typeLabel]="'conteggioProspettoBold'" [valueInput]="totaleImponibile">
                    </div>
                    <div labelTextInput
                        [labelInput]="('Iva ' + (tariffa.iva ? (tariffa.iva.valore + '%'  + ' su imponibile') : '0% su imponibile' ))"
                        [typeLabel]="'conteggioProspetto'"
                        [valueInput]="(totaleImponibile * (tariffa.iva ? tariffa.iva.valore : 0) / 100)">
                    </div>
                    <div labelTextInput [labelInput]="'Spese esenti IVA ex art. 15 DPR 633/72'"
                        [typeLabel]="'conteggioProspetto'" [valueInput]="tariffa.speseEsenti">
                    </div>

                    <div *ngIf="!isModifica" labelTextInput [labelInput]="'Totale tariffa'"
                        [typeLabel]="'conteggioProspettoBold'" [valueInput]="tariffa.totaleSpese"></div>
                    <div *ngIf="isModifica" labelTextInput [labelInput]="'Totale tariffa'"
                        [typeLabel]="'conteggioProspettoBold'" [valueInput]="totaleTariffa"></div>
                </div>
                        <div class="row" *ngIf="isModifica">
                            <p class="col-sm-3 col-xs-6" style="padding-left: 30px;">
                                <button type="button" class="btn btn-outline-secondary btn-block"
                                    (click)="riepilogo = false;">Indietro</button>
                            </p>
                            <p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6"
                                (click)="salvaTariffa()" [labelButton]="'Salva'"></p>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

    </div>
</div>





<!-- <ng-template [ngIf]="tariffa && !riepilogo">
	<div class="col-sm-12 coldx" >
		<h4>Revisiona tariffa</h4>
	</div>
	<div class="row">
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo prestazione'"
			[valueInput]="tariffa.attivita ? tariffa.attivita.descrizione : ''"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Grado'"
			[valueInput]="tariffa.grado ? tariffa.grado.descrizione : ''"></div>
		<p class="col-sm-2 col-sm-offset-2">
			<button type="button" class="btn btn-block" (click)="ripristinaTariffaOriginale()">Ripristina
				originale</button>
		</p>
	</div>
	<div class="container_conteggi">
		<h5>
			<strong>Importi tariffa</strong>
		</h5>
		<div textInputCurrency [labelInput]="'Imponibile'" [(ngModel)]="tariffa.imponibile">
		</div>
		<div textInputCurrency [labelInput]="'Spese generali'" [(ngModel)]="tariffa.speseGenerali">
		</div>
		<div textInputCurrency [labelInput]="'Spese a pié di lista'" [(ngModel)]="tariffa.spesePiePagina">
		</div>
		<div textInputCurrency [labelInput]="'Spese esenti IVA ex art. 15 DPR 633/72'"
			[(ngModel)]="tariffa.speseEsenti">
		</div>
		<div textInputCurrency [labelInput]="'Maggiorazione p.d..'" [(ngModel)]="tariffa.maggiorazione">
		</div>
	</div>
	<div class="container_conteggi">
		<h5>
			<strong>Accessori</strong>
		</h5>

		<div class="row">
			<div class="parcella_accessori col-sm-offset-2">
				<div singleCheckBoxModInput class="col-sm-2" [labelInput]="''" idInput="flagIva"
					(onReturn)="flagIVA = $event; changeFlag()" [labelChecked]="'IVA'" [labelNotChecked]="'IVA'"
					[objectReference]="flagIVA"></div>

				<div comboModInput class="col-sm-3" [labelInput]="''" [labelOption]="'valore'"
					[submitPending]="!flagIVA" [optionsCombo]="ivaOptions" (onReturn)="tariffa.iva = $event"
					[objectReference]="tariffa.iva"></div>

				<div class="col-sm-2" singleCheckBoxModInput [labelInput]="''"
					(onReturn)="flagCPA = $event; changeFlag()" [labelChecked]="'CPA'" [labelNotChecked]="'CPA'"
					[showLabel]="true" [objectReference]="flagCPA"></div>

				<div comboModInput class="col-sm-3" [labelInput]="''" [labelOption]="'valore'"
					[optionsCombo]="cpaOptions" [submitPending]="!flagCPA" (onReturn)="tariffa.cpa = $event"
					[objectReference]="tariffa.cpa"></div>
			</div>
		</div>
	</div>

	<div class="row">
		<p class="col-sm-3 col-xs-3">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="tariffa = null">Indietro</button>
		</p>
		<p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" (click)="riepilogo = true;"
			[labelButton]="'Calcola tariffa'" [disabled]="!tariffa.grado && !tariffa.attivita"></p>
	</div>
</ng-template>


<ng-template [ngIf]="tariffa && riepilogo">

	<div class="titleblock">
		<h3 class="title1level" style="margin-bottom: 20px">Riepilogo</h3>
	</div>
	<div class="row">
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo prestazione'"
			[valueInput]="tariffa.attivita ? tariffa.attivita.descrizione : ''"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Grado'"
			[valueInput]="tariffa.grado ? tariffa.grado.descrizione : ''"></div>
	</div>
	<div class="container_conteggi">
		<h5>
			<strong>Prospetto finale</strong>
		</h5>
		<div *ngFor="let cpa of [( tariffa.cpa ?  (tariffa.imponibile | percentage:tariffa.cpa.valore) : 0)]">
			<div
				*ngFor="let iva of [( tariffa.iva ?  (tariffa.imponibile | percentage:tariffa.iva.valore) : 0)]">
				<div *ngFor="let totale of [( getSum(tariffa.imponibile, tariffa.maggiorazione,
				tariffa.speseGenerali, tariffa.spesePiePagina, tariffa.speseEsenti,
							iva, cpa ))]">
					<div labelTextInput [labelInput]="'Imponibile'" [typeLabel]="'conteggioProspetto'"
						[valueInput]="tariffa.imponibile"></div>
					<div *ngIf="tariffa.iva">
						<div labelTextInput [labelInput]="'% IVA'" [typeLabel]="'conteggioPerc'"
							[valueInput]="tariffa.iva.valore">
						</div>
						<div labelTextInput [labelInput]="'Importo IVA (calcolato in base alla %)'"
							[typeLabel]="'conteggioProspetto'" [valueInput]="iva.replace(',','.')">
						</div>
					</div>
					<div *ngIf="tariffa.cpa">
						<div labelTextInput [labelInput]="'% CPA'" [typeLabel]="'conteggioPerc'"
							[valueInput]="tariffa.cpa.valore">
						</div>
						<div labelTextInput [labelInput]="'Importo CPA (calcolato in base alla %)'"
							[typeLabel]="'conteggioProspetto'" [valueInput]="cpa.replace(',','.')">
						</div>
					</div>
					<div labelTextInput [labelInput]="'Spese generali'" [typeLabel]="'conteggioProspetto'"
						[valueInput]="tariffa.speseGenerali"></div>
					<div labelTextInput [labelInput]="'Spese a pié di lista'" [typeLabel]="'conteggioProspetto'"
						[valueInput]="tariffa.spesePiePagina"></div>
					<div labelTextInput [labelInput]="'Spese esenti IVA ex art. 15 DPR 633/72'"
						[typeLabel]="'conteggioProspetto'" [valueInput]="tariffa.speseEsenti"></div>
					<div labelTextInput [labelInput]="'Maggiorazione p.d..'" [typeLabel]="'conteggioProspetto'"
						[valueInput]="tariffa.maggiorazione"></div>

					<div labelTextInput [labelInput]="'Totale tariffa'" [typeLabel]="'conteggioProspettoBold'"
						[valueInput]="totale.replace(',','.')"></div>
				</div>
			</div>
		</div>

	</div>


	<div class="row">
		<p class="col-sm-3 col-xs-3">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="riepilogo = false;">Indietro</button>
		</p>
		<p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" (click)="salvaTariffa()"
			[labelButton]="'Salva'"></p>
	</div>
</ng-template> -->